<div cdkTrapFocus class="comments-overlay" tabindex="0" (keyup.escape) ="close()"  (keyup.enter)="close()" (click)="close()"></div>
<div cdkTrapFocus  (keyup.escape) ="close()" class="comments-panel">
    <div class="comments-header">
        <div class="comments-header-title">
            <div (keyup.escape) ="close()" class="chat-title">
                <span style="font-size:18px;font-weight: 500;" class="tmi tmi-comment"></span> &nbsp;&nbsp; Chat</div>
            <div>
            <div tabindex="0"  (keyup.escape) ="close()" id="crossIcon" (keyup.enter)="close()" (click)="close()" style="cursor: pointer;font-weight: 600;" class="tmi tmi-close"></div>
            </div>
        </div>
        <div class="comments-header-action-horizontal-line"></div>
        <div class="comments-header-action">
            <div class="row-1">
                <div
                    class="message-count">
                    {{comments.length}} MESSAGES</div>
                <div tabindex="0"  (keyup.enter)="clearall()" (click)="clearall()"  class="clearall">clear all</div>
            </div>
            
        </div>
    </div>
    <div class="comments-body" cdkScrollBar>
        <ng-container *ngFor="let comment of comments;let i = index;">
            <div id="ChatCard{{i}}"  class="comments-card" tabindex="0"  (keyup.escape) ="close()" (keyup.enter)="navigateToWriteup(comment)" (click)="navigateToWriteup(comment)">
                <div class="row" style="position:relative ;">
                    <div class="comments-highlight">
                        <span style="font-size: 16px; font-weight: 100;" class="tmi tmi-comment"></span>&nbsp;
                        <span *ngIf="comment.type === 'DEAL_COMMENT'">{{comment?.deal?.dealTermComment?.commentGivenBy | uppercase}}</span>
                        <span *ngIf="comment.type === 'DEAL_UPDATE'">{{comment?.deal?.salesPerson | uppercase}}</span>
                    </div><span  tabindex="0"  (keyup.enter)="clear(comment)" (click)="clear(comment)" class="tmi tmi-close comments-close"></span>
                </div>
                <div class="car-details-row">
                    <span *ngIf="comment.type === 'DEAL_COMMENT'">{{comment?.deal?.vehicle?.modelYear}}&nbsp;{{comment?.deal?.vehicle?.brand}}&nbsp;{{comment?.deal?.vehicle?.modelMarketingName}}</span>
                    <span *ngIf="comment.type === 'DEAL_UPDATE'">{{comment?.vehicle?.modelYear}}&nbsp;{{comment?.vehicle?.brand}}&nbsp;{{comment?.vehicle?.modelMarketingName}}</span>
                    <br>
                    {{comment?.deal?.writeupType}} <span style="float: right;
                    margin-right: 10px;">
                    <span *ngIf="comment.type === 'DEAL_COMMENT'">{{comment?.deal?.dealTermComment?.commentDate | date: 'MM-dd-yyyy'}}</span>
                    <span *ngIf="comment.type === 'DEAL_UPDATE'">{{comment?.deal?.dealTermComment?.updatedDate | date: 'MM-dd-yyyy'}}</span>
                    </span>  
                </div>
                <div class="comments-content">
                    <div class="content">
                        <span *ngIf="comment.type === 'DEAL_COMMENT'">{{comment?.deal?.dealTermComment?.commentTXT}}</span>
                        <span *ngIf="comment.type === 'DEAL_UPDATE'">Message</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
